<script setup lang="tsx">
import { watch } from 'vue'

const model = defineModel({ default: false })
const emit = defineEmits(['open', 'close'])
watch(model, () => (model.value ? emit('open') : emit('close')))
</script>

<template>
	<i
		class="method-expand-icon bi align-middle fs-5"
		:class="{ 'bi-dash-square': model, 'bi-plus-square': !model }"
		@click="model = !model"
	></i>
</template>
